const coms = require.context('./', true, /\.vue$/)

export default {
    install(Vue) {
        coms.keys().map(v => {
            Vue.component(coms(v).default.name, coms(v).default)
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js